<template>
  <div class="home">
    <nav-head></nav-head>
    <div class="banner">
      <div class="ban-jia">
        <img src="~assets/images/home/ban-txt.png">
        <div class="world-jia">全国火热加盟中</div>
      </div>
      <div class="ban-msk">
        <div><img src="~assets/images/home/target.png"><p>10年深耕查重市场</p></div>
        <div class="line"></div>
        <div><img src="~assets/images/home/diamond.png"><p>数百家加盟商信赖</p></div>
        <div class="line"></div>
        <div><img src="~assets/images/home/revenue.png"><p>无障碍盈利</p></div>
      </div>
    </div>
    <div class="gxsc">
      <div class="second-title">
        <img class="wen1" src="~assets/images/home/wen1.png">
        <p>不管是大学生、研究生、博士生毕业还是评职称均需要发表论文</p>
        <div class="underline"></div>
      </div>
      <div class="dev">
        <div class="dev-head">
          <img src="~assets/images/home/logo_03.png">
          未来市场有望扩大十倍
        </div>
        <div class="dev-per">
          <per-cent v-for="item in dev" :perData="item"></per-cent>
          <ul class="dev-list">
            <li><span></span>毕业人数(万人)</li>
            <li><span></span>同比增长(%)</li>
          </ul>
          <div class="dev-txt">
            未来，中国的教育也将向西方先进国家市场看齐，
            查重需求将从高校毕业生延伸到初高中生，
            届时<span>查重市场规模将激增10倍以上。</span>
          </div>
        </div>
      </div>
    </div>
    <div class="shjm">
      <div class="second-title">
        <div>
          <img class="wen2" src="~assets/images/home/wen2.png">
        </div>
        <div class="underline"></div>
      </div>
      <div class="right-peo">
        <div>
          <img src="~assets/images/home/student_img.png">
          <h3>在校学生或老师</h3>
          <p>拥有校园资源的公司</p>
          <p>老师或者在校大学生</p>
        </div>
        <div>
          <img src="~assets/images/home/e-commerce_img.png">
          <h3>自媒体或电商人</h3>
          <p>想寻找投资少</p>
          <p>利润高的创业之士</p>
        </div>
        <div>
          <img src="~assets/images/home/teacher_img.png">
          <h3>教育相关企业</h3>
          <p>具有互联网营销经验</p>
          <p>或者渠道分销经验的能人</p>
        </div>
        <div>
          <img src="~assets/images/home/schoolshop_img.png">
          <h3>校园实体店铺</h3>
          <p>线上线下有力结合</p>
          <p>营业额成成上涨</p>
        </div>
      </div>
      <router-link class="btn" :to="{path:'contact?#info'}">
        立即加盟
      </router-link>
    </div>
    <div class="swiper">
      <div class="second-title">
        <div><img class="wen3" src="~assets/images/home/wen3.png"></div>
        <div class="underline"></div>
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="~assets/images/home/cus01.png">
            <div class="s-cont">
              <h3>客户A</h3>
              <div>
                客户A为在校大学生，学校每年都有毕业论文检测需求。他了解到学校是什么系统检测时，利用业余时间在学校论坛、各种班级群传播检测网址，仅半个学期，为自己赚取了人生第一桶金。
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="~assets/images/home/cus02.png">
            <div class="s-cont">
              <h3>客户B</h3>
              <div>
                客户B团队拥有电商经验，该客户分小组运作，在我们平台拥有多个代理商帐号，其在淘宝、京东等多平台进行电商销售，每年利润可观。
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="~assets/images/home/cus03.png">
            <div class="s-cont">
              <h3>客户C</h3>
              <div>
                客户C拥有渠道分销经验，2018年加入检测行业，在我们的技术扶持下，利润以每年以5%的速度进行增值。
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <img src="~assets/images/home/cus04.png">
            <div class="s-cont">
              <h3>客户D</h3>
              <div>
                客户D校园内开设了一家打印店，2018年底加入我们，在我们活动与宣传物料支持下，半年盈利以超过其打印店盈利。
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-prev swiper-button-white" style="padding: 15px 5px;background: rgba(0,0,0,.4);outline: unset"></div>
        <div class="swiper-button-next swiper-button-white" style="padding: 15px 5px;background: rgba(0,0,0,.4);outline: unset"></div>
      </div>
    </div>
    <div class="qdbz">
      <div class="second-title" style="background: #fafafa">
        <div><img class="wen4" src="~assets/images/home/wen4.png"></div>
        <div class="underline"></div>
      </div>
      <div class="ser-wrap">
        <div class="security">
          <img src="~assets/images/home/security1.png">
          <div>
            <p>高保障</p>
            <div class="txt">
              成功运营10年,检测行业老品牌，有良好的口碑和市场影响力。
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security2.png">
          <div>
            <p>技术强悍</p>
            <div class="txt">
              以技术为先导,以市场为导向,注重技术投入,保证系统的安全性、
              及时性和稳定性,提高代理的市场竞争力
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security3.png">
          <div>
            <p>投入少</p>
            <div class="txt">
              0加盟费即可试用,系统可24小时自助检测,资金周转快,
              加盟即送一套价值上万的论文检测网站推广源码,一人就可轻松创业
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security4.jpg">
          <div>
            <p>收益高</p>
            <div class="txt">
              一手低价货源，不同产品收益不同，多种检测产品组合销售。
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security5.png">
          <div>
            <p>服务优</p>
            <div class="txt">
              加盟后提供一对一专属客服,便于交流与问题反馈,客服全年无休,
              帮助商家解决各种疑难问题
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security6.png">
          <div>
            <p>市场大</p>
            <div class="txt">
              全国每年高校毕业人数高达800多万,随着高等教育的普及毕业生人数仍将逐年递增,
              且行业从事者少、竞争小,利润大
            </div>
          </div>
        </div>
        <div class="security">
          <img src="~assets/images/home/security7.png">
          <div>
            <p>后劲足</p>
            <div class="txt">
              平台将扩展现有检测业务,从衍生业务如广告、知识付费等多元 渠道实现二次变现,不断增强商家的盈利能力
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xzwm">
      <div class="second-title">
        <div><img class="wen5" src="~assets/images/home/wen5.png"></div>
        <div class="underline"></div>
      </div>
      <div class="cho">
        <div>
          <img src="~assets/images/home/cho1.jpg">
          <h3>正规公司</h3>
          <p>百万注册资金</p>
          <p>上万客户信赖</p>
        </div>
        <div>
          <img src="~assets/images/home/cho2.png">
          <h3>明码标价</h3>
          <p>拒绝隐性消费</p>
          <p>拒绝套路消费</p>
        </div>
        <div>
          <img src="~assets/images/home/cho3.png">
          <h3>先试后付</h3>
          <p>先开通试用账号</p>
          <p>免费体验平台功能</p>
        </div>
        <div>
          <img src="~assets/images/home/cho4.png">
          <h3>终生指导</h3>
          <p>资深讲师团队</p>
          <p>终身给予指导</p>
        </div>
      </div>
    </div>
    <div class="flow">
      <div class="second-title" >
        <div><img class="wen5" src="~assets/images/home/wen6.png"></div>
        <div class="underline"></div>
      </div>
      <div>
        <img src="~assets/images/home/step.png">
      </div>
    </div>
    <div class="partner">
      <div class="second-title" >
        <div><img class="wen7" src="~assets/images/home/wen7.png"></div>
        <div class="underline"></div>
      </div>
      <div class="part-items">
        <div><img src="~assets/images/home/logo2_06.png?v1"></div>
        <div><img src="~assets/images/home/logo_ywj.png"></div>
        <div><img src="~assets/images/home/logo1_03.png" style="height: 1.66rem;"></div>
        <div><img src="~assets/images/home/part03.png"></div>
        <div><img src="~assets/images/home/part04.png"></div>
        <div><img src="~assets/images/home/part08.png"></div>
        <div><img src="~assets/images/home/part07.png"></div>
        <div><img src="~assets/images/home/part05.png"></div>
        <div><img src="~assets/images/home/dgxt.png"></div>


      </div>
    </div>
<!--    <div class="college">-->
<!--      <div class="second-title" >-->
<!--        <div><img class="wen7" src="~assets/images/home/wen8.png"></div>-->
<!--        <div class="underline"></div>-->
<!--      </div>-->
<!--      <div class="coll-bg"><img src="~assets/images/home/college.jpg"></div>-->
<!--    </div>-->
    <input-wrap></input-wrap>
    <back-top></back-top>
    <footer-version></footer-version>
  </div>
</template>

<script>

import {NavHead,PerCent,FooterVersion,InputWrap,BackTop} from "../components";
import 'swiper/css/swiper.css'
import Swiper from 'swiper';
import {linkRefresh} from "../common/mixin";

export default {
  name: 'Home',
  components: {
    NavHead,
    PerCent,
    FooterVersion,
    InputWrap,
    BackTop
  },
  data() {
    return {
      dev:[
        {year:2013,people:631,percent:3.4},
        {year:2014,people:660,percent:4.6},
        {year:2015,people:680,percent:3.0},
        {year:2016,people:699,percent:2.8},
        {year:2017,people:727,percent:4.0},
        {year:2018,people:749,percent:2.9},
        {year:2019,people:765,percent:2.1},
        {year:2020,people:874,percent:3.9},
        {year:2021,people:909,percent:3.1},
        {year:2022,people:1076,percent:1.7}
      ],
      show:false
    }
  },
  mixins:[linkRefresh],
  mounted() {
    new Swiper ('.swiper-container',{
      loop:true,
      effect : 'coverflow',
      // slidesPerView: 2,
      slidesPerView:'auto',
      centeredSlides: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 10,
        depth: 60,
        modifier: 2,
        slideShadows : false
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  },
  methods: {
    showPopup() {
      this.show = true;
    }
  },
  computed: {
  }
}
</script>
<style scoped lang="less">
  .home {
    font-size: 20px;
  }
  .banner {
    height: 495px;
    background-image: url("~assets/images/home/banner_03.jpg");
    background-size: 100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .ban-jia {
      /*object-fit: fill;*/
      margin: 60px 0 0 30px;
      img {
        height: 164px;
        width: 272px;
      }
      .world-jia {
        background: linear-gradient(90deg,#a9dcfe,#fff);
        color: #252525;
        width: 275px;
        letter-spacing: 20px;
        white-space: nowrap;
        padding: 5px 10px;
        margin-top: 20px;
      }
    }
    .ban-msk {
      height: 136px;
      background: rgba(0,0,0,.4);
      padding: 0 30px;
      width: 100%;
      font-size: 24px;
      color: #fff;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 30px;
      box-sizing: border-box;
      div {
        text-align: center;
        img {
          width: 38px;
          object-fit: contain;
          margin-bottom: 10px;
        }
      }
      .line {
        border-left: 1px solid #fff;
        height: 100%;
      }

    }
  }
  .second-title {
    text-align: center;
    padding-top: 65px;
    .wen1 {
      height: 50px;
    }
    .wen2 {
      height: 75px;
    }
    .wen3 {
      height: 80px;
    }
    .wen4 {
      height: 78px;
    }
    .wen5 {
      height: 79px;
    }
    .wen7 {
      height: 81px;
    }
    .wen9 {
      height: 108px;
    }
    p {
      color:#858585;
      margin-top: 10px;
    }
    .underline {
      display: inline-block;
      width: 20%;
      border-bottom: 2px solid #126eac;
      height: 2px;
      margin: 15px 0;
    }
  }
  .dev{
    margin: 10px 30px;
    box-shadow: 0 0 5px 1px #dcdddd;
    .dev-head {
      height: 85px;
      background: linear-gradient(0deg,#1974b0,#5aaad7);
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      font-size: 30px;
      color: #fff;
      img {
        height: 38px;
      }
    }
    .dev-per {
      padding: 20px 30px;
    }
    .dev-list {
      list-style: none;
      padding: 40px 0;
      border-bottom: 1px dashed #dcdddd;
      li {
        display: inline-block;
        span {
          display: inline-block;
          width: 40px;
          height: 20px;
          margin: 0 20px;
        }
        &:first-child {
          color: #126eac;
          span {
            background: #126eac;
          }
        }
        &:last-child {
          color: #f2911d;
          margin-left: 20px;
          span {
            background: #f2911d;
          }
        }
      }
    }
    .dev-txt {
      padding: 30px 0;
      font-size: 24px;
      color: #979797;
      span {
        color: #1974b0;
      }
    }
  }
  .right-peo,.cho {
    display: flex;
    padding: 35px;
    justify-content: space-around;
    flex-wrap: wrap;
    text-align: center;
    div {
      border: 1px solid #97c0db;
      width: 46%;
      margin-bottom: 20px;
      padding: 40px 0 50px;
      border-radius: 5px;
      img {
        height: 124px;
      }
      h3 {
        font-size: 30px;
        color: #3c3c3c;
        padding: 20px 0;
      }
      p {
        color: #919191;
      }

    }
  }
  .btn {
    padding: 20px 0;
    margin: 0 40px;
    display: block;
    text-align: center;
    background: linear-gradient(90deg,#126eac,#5aaad7);
    font-size: 36px;
    color: #fff;
    border-radius: 5px;
  }
  .swiper-container {
      margin: 0 40px;
      padding: 0;
      height: 500px;
    .swiper-wrapper {
      .swiper-slide {
        height: 500px;
        width: 439px;
        position: relative;
        color: #fff;
        font-size: 20px;
        img {
          width: 100%;
          height: 100%;
        }
        .s-cont {
          position: absolute;
          top: 180px;
          padding: 30px;
          h3 {
            font-size: 60px;
            color: #abbdc6;
            margin-bottom: 20px;
          }
        }
      }
      .swiper-button-prev,.swiper-button-next {
        padding: 15px 5px !important;
        background: rgba(0,0,0,.4) !important;
      }
    }

  }
  .ser-wrap {
    padding: 20px 30px;
    background: #fafafa;
    .security {
      display: flex;
      align-items: center;
      height: 160px;
      margin: 20px 0;
      box-sizing: border-box;
      background: #fff;
      img {
        height: 55px;
        padding: 0 30px;
      }
      p {
        color: #252525;
        font-size: 30px;
        font-weight: bold;
        padding-bottom: 10px;
      }
      .txt {
        color: #666;
        font-size: 20px;
        padding-right: 20px;
      }
    }
  }
  .cho {
    background: url("~assets/images/home/cho-bg.png") no-repeat center/100%;
    justify-content: space-between;
    div {
      width: 45%;
      border: none;
      img {
        height: 217px;
      }
    }
  }
  .flow {
    background: #f7fcff;
    text-align: center;
    padding-bottom: 80px;
    .second-title {
      background: linear-gradient(180deg,#fff,#f7fcff);
    }
    img {
      height: 700px;
    }
  }
  .partner {
    padding: 0 30px;
    .part-items {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      div {
        width: 45%;
        height: 174px;
        border: 1px solid #dfdfdf;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
        img {
          height: 65px;
        }
      }
    }
  }
  .college {
    .coll-bg {
      text-align: center;
      margin-top: 20px;
      img {
        height: 340px;
      }
    }
  }


</style>
